import React from 'react';
import css from './OfferSection.module.css';

const OfferSection = () => {
  return (
    <div className={css.wrapper}>
      <img src="/static/offers/month-offer.jpg" className={css.offerImg} alt="" />
    </div>
  );
};

export default OfferSection;
